import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { Button, ButtonProps } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useReportCtx } from '../../../report-ctx';

/**
 * Reset report form button (icon only). Same style as list-view RefreshButton (outlined, secondary).
 */
export const ResetReportBtnRhf = ({
  onReset,
  ...rest
}: {
  onReset?: VoidFunction;
} & Partial<ButtonProps>) => {
  const { reset, formState } = useFormContext();
  const ctx = useReportCtx();

  return (
    <Button
      size="small"
      variant="outlined"
      color="secondary"
      onClick={() => {
        reset(ctx.defaultValues || {});
        ctx.runReport(ctx.defaultValues || {});
        onReset?.();
      }}
      disabled={!formState.isValid || ctx.isLoading}
      sx={{ padding: 0, minWidth: '44px' }}
      {...rest}
    >
      <RestartAltIcon fontSize="small" />
    </Button>
  );
};
